import { SlideChannelNormalizationResultSummary } from 'api/slideMultiplexChannelNormalizations';
import { buildNormalizationCoverageWarning, synchronizeSelectedChannelProfiles } from '../helpers';
import {
  MultiplexBlobSegmentationChannelProfile,
  multiplexBlobSegmentationDefaultClosingKernelSizeUm,
  multiplexBlobSegmentationDefaultMedianFilterSizeUm,
  multiplexBlobSegmentationDefaultMinBlobAreaUm2,
  multiplexBlobSegmentationDefaultOpeningKernelSizeUm,
  multiplexBlobSegmentationDefaultSmoothingKernelSizeUm,
  multiplexBlobSegmentationDefaultThreshold,
} from './types';

export const buildDefaultBlobSegmentationChannelProfile = (): MultiplexBlobSegmentationChannelProfile => ({
  medianFilterSizeUm: multiplexBlobSegmentationDefaultMedianFilterSizeUm,
  threshold: multiplexBlobSegmentationDefaultThreshold,
  openingKernelSizeUm: multiplexBlobSegmentationDefaultOpeningKernelSizeUm,
  closingKernelSizeUm: multiplexBlobSegmentationDefaultClosingKernelSizeUm,
  minBlobAreaUm2: multiplexBlobSegmentationDefaultMinBlobAreaUm2,
  smoothingKernelSizeUm: multiplexBlobSegmentationDefaultSmoothingKernelSizeUm,
});

export const synchronizeBlobSegmentationProfiles = ({
  selectedChannelNames,
  profiles,
}: {
  selectedChannelNames: string[];
  profiles?: Record<string, MultiplexBlobSegmentationChannelProfile> | null;
}) => {
  return synchronizeSelectedChannelProfiles({
    selectedChannelNames,
    profiles,
    buildDefaultProfile: buildDefaultBlobSegmentationChannelProfile,
  });
};

export const buildBlobSegmentationNormalizationWarning = ({
  normalizationSummaries,
  selectedChannelNames,
  channelLabelsByName,
  selectedSlideIds,
  normalizationName,
}: {
  normalizationSummaries?: SlideChannelNormalizationResultSummary[];
  selectedChannelNames: string[];
  channelLabelsByName?: Record<string, string>;
  selectedSlideIds?: string[];
  normalizationName?: string | null;
}) => {
  return buildNormalizationCoverageWarning({
    normalizationSummaries,
    selectedChannelNames,
    channelLabelsByName,
    selectedSlideIds,
    normalizationName,
    actionLabel: 'Blob segmentation',
    selectedChannelsLabel: 'markers',
  });
};
